module.exports = __webpack_public_path__ + "img/IMG_5378.3718b42b.jpg";